import * as React from 'react';
import { Link } from 'react-scroll';
import Button, {
  ButtonColor,
  ButtonSize,
} from '../../../common/buttons/Button';
import StoresReserveColorLogo from '../../../common/logos/StoresReserveColorLogo';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import css from './BizHeroSection.module.scss';

const BizHeroSection = ({ intl }: InjectedIntlProps) => {
  const intlPref = 'explore.index.bizHero.';

  return (
    <div className={css.BizHeroSection}>
      <section className={css.BizHeroSection__ForConsumer}>
        <article className={css.BizHeroSection__ForConsumerArticle}>
          <div className={css.BizHeroSection__TextContainer}>
            <h1 className={css.BizHeroSection__ForConsumerTitle}>
              {intl.formatMessage({ id: intlPref + 'forCustomer.title' })}
            </h1>
            <h2 className={css.BizHeroSection__Copy}>
              {intl.formatHTMLMessage({ id: intlPref + 'forCustomer.copy' })}
            </h2>
            <div className={css.BizHeroSection__LogoContainer}>
              <svg className={css.BizHeroSection__CoubicLogo}>
                <use xlinkHref="#logo-brand" />
              </svg>
            </div>
            <div className={css.BizHeroSection__ButtonContainer}>
              <Button
                buttonSize={ButtonSize.Medium}
                className={css.BizHeroSection__Button}
                tag={'div'}
              >
                {intl.formatMessage({ id: intlPref + 'forCustomer.button' })}
                <Link
                  to="findMerchants"
                  spy={true}
                  smooth={true}
                  duration={500}
                />
              </Button>
            </div>
          </div>
          <picture className={css.BizHeroSection__ScreenImageContainer}>
            <source
              srcSet="https://d3jf92lm1e7l6.cloudfront.net/images/coubic/explore/hero-sp-pc-screen.png"
              media="all and (min-width: 480px)"
            />
            <img
              className={css.BizHeroSection__ScreenImage}
              src="https://d3jf92lm1e7l6.cloudfront.net/images/coubic/explore/hero-sp-screen.png"
            />
          </picture>
        </article>
      </section>
      <section className={css.BizHeroSection__ForProvider}>
        <article className={css.BizHeroSection__ForProviderArticle}>
          <div className={css.BizHeroSection__TextContainer}>
            <h1 className={css.BizHeroSection__ForProviderTitle}>
              {intl.formatMessage({ id: intlPref + 'forProvider.title' })}
            </h1>
            <h2 className={css.BizHeroSection__Copy}>
              {intl.formatMessage({ id: intlPref + 'forProvider.copy' })}
            </h2>
            <div className={css.BizHeroSection__LogoContainer}>
              <StoresReserveColorLogo
                className={css.BizHeroSection__StoresLogo}
              />
            </div>
            <div className={css.BizHeroSection__ButtonContainer}>
              <Button
                buttonColor={ButtonColor.Biz}
                buttonSize={ButtonSize.Medium}
                className={css.BizHeroSection__Button}
                href="https://stores.jp/reserve"
              >
                {intl.formatMessage({ id: intlPref + 'forProvider.button' })}
              </Button>
            </div>
            <div className={css.BizHeroSection__Note}>
              {intl.formatMessage({ id: intlPref + 'forProvider.note' })}
            </div>
          </div>
          <picture className={css.BizHeroSection__ScreenImageContainer}>
            <source
              srcSet="https://d3jf92lm1e7l6.cloudfront.net/images/coubic/explore/hero-sp-pc-screen-for-biz.png"
              media="all and (min-width: 480px)"
            />
            <img
              className={css.BizHeroSection__ScreenImage}
              src="https://d3jf92lm1e7l6.cloudfront.net/images/coubic/explore/hero-sp-screen-for-biz.png"
            />
          </picture>
        </article>
      </section>
    </div>
  );
};

export default injectIntl(BizHeroSection);
